<template>
  <div id="app">
    <NavBar />
    <BModalOrchestrator></BModalOrchestrator>
    <BToastOrchestrator></BToastOrchestrator>
    <div class="main container">
      <router-view />
    </div>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
import NavBar from "@/components/NavBar.vue";
import { BModalOrchestrator, BToastOrchestrator } from "bootstrap-vue-next";

export default {
  components: {
    NavBar,
    BModalOrchestrator,
    BToastOrchestrator,
  },
  mounted() {
    this.checkAuth();
    setInterval( function(){
            this.checkAuth();
        }.bind(this), 60000);
  },
  methods: {
    async checkAuth() {
      await this.$store.dispatch('viewMe');

      if (!this.$store.getters.isAuthenticated) {
        this.$router.push('/login');
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main {
  padding-top: 2em;
}
</style>
